import type React from "react";
import { createContext, useCallback, useContext, useMemo, useState } from "react";
interface ScreenLockContextInterface {
  isScreenLockSuppressed: boolean;
  disableScreenLock: () => void;
  enableScreenLock: () => void;
}
const initialContext: ScreenLockContextInterface = {
  isScreenLockSuppressed: false,
  disableScreenLock: () => {
    throw new Error("ScreenLockProvider not initialized");
  },
  enableScreenLock: () => {
    throw new Error("ScreenLockProvider not initialized");
  }
};
const ScreenLockContext = createContext<ScreenLockContextInterface>(initialContext);
interface ScreenLockProviderProps {
  children: React.ReactNode;
}
export const ScreenLockProvider = ({
  children
}: ScreenLockProviderProps) => {
  const [isScreenLockSuppressed, setIsScreenLockSuppressed] = useState(false);
  const disableScreenLock = useCallback(() => {
    setIsScreenLockSuppressed(true);
  }, []);
  const enableScreenLock = useCallback(() => {
    setIsScreenLockSuppressed(false);
  }, []);
  const contextValue = useMemo<ScreenLockContextInterface>(() => ({
    isScreenLockSuppressed,
    disableScreenLock,
    enableScreenLock
  }), [isScreenLockSuppressed, disableScreenLock, enableScreenLock]);
  return <ScreenLockContext.Provider value={contextValue} data-sentry-element="ScreenLockContext.Provider" data-sentry-component="ScreenLockProvider" data-sentry-source-file="screenLockProvider.tsx">
      {children}
    </ScreenLockContext.Provider>;
};
export const useScreenLock = (): ScreenLockContextInterface => {
  const context = useContext(ScreenLockContext);
  if (!context) {
    throw new Error("useScreenLock must be used within a ScreenLockProvider");
  }
  return context;
};